// Portuguese national holidays source for FullCalendar.
// Uses Google's official public iCal feed so dates stay accurate forever
// (including movable holidays like Easter, Carnival and Corpus Christi).
import iCalendarPlugin from '@fullcalendar/icalendar'

export const HOLIDAYS_SOURCE_ID = 'pt-holidays'

// Served by HolidaysController, which proxies and caches Google's
// official Portuguese holidays iCal feed. Going through our backend
// avoids CORS issues with the upstream Google endpoint.
export const HOLIDAYS_ICAL_URL = '/holidays/portugal'

// Match the holidays toggle button's active state: yellow-50 background,
// yellow-300 ring, yellow-800 text.
export const HOLIDAY_COLOR = '#fefce8' // yellow-50 background
export const HOLIDAY_BORDER_COLOR = '#fde047' // yellow-300 ring
export const HOLIDAY_TEXT_COLOR = '#854d0e' // yellow-800 text

export const holidaysPlugin = iCalendarPlugin

export function buildHolidaysSource() {
  return {
    id: HOLIDAYS_SOURCE_ID,
    url: HOLIDAYS_ICAL_URL,
    format: 'ics',
    backgroundColor: HOLIDAY_COLOR,
    borderColor: HOLIDAY_BORDER_COLOR,
    textColor: HOLIDAY_TEXT_COLOR,
    display: 'block',
    classNames: ['holiday-event'],
    editable: false
  }
}

export function isHolidayEvent(event) {
  return event?.source?.id === HOLIDAYS_SOURCE_ID
}
